// extracted by mini-css-extract-plugin
export var image = "MarkdownBadgeGooglePlay-module--image--71413";
export var root = "MarkdownBadgeGooglePlay-module--root--fbba4";